import { render } from "./DayWrapper.vue?vue&type=template&id=edf9ce00"
import script from "./DayWrapper.vue?vue&type=script&lang=js"
export * from "./DayWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__